/**
 * CS Card FX — Premium Perfume Store
 * Effects: 3D tilt · scent particles · image parallax · border trace · idle glow
 */
(function () {
  'use strict';

  /* ── Config ── */
  const CONFIG = {
    tilt: { max: 18, perspective: 900, speed: 400 },
    parallax: { depth: 12 },
    particles: { count: 8, colors: ['#fbb324', '#ffd066', '#fff3cc', '#d49a1a'] },
  };

  /* ── Utility ── */
  function lerp(a, b, t) { return a + (b - a) * t; }
  function clamp(v, min, max) { return Math.min(Math.max(v, min), max); }

  /* ── Init all cards ── */
  function initCards() {
    document.querySelectorAll('.cs-fx-card:not([data-cs-fx-inited])').forEach(initCard);
  }

  function initCard(card) {
    card.setAttribute('data-cs-fx-inited', '1');

    /* Build particle canvas overlay */
    const canvas = document.createElement('canvas');
    canvas.className = 'cs-fx-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.style.cssText = `
      position:absolute;top:0;left:0;width:100%;height:100%;
      pointer-events:none;z-index:5;border-radius:inherit;
    `;
    card.style.position = 'relative';
    card.appendChild(canvas);

    /* Build border-trace SVG overlay */
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = `
      position:absolute;inset:0;width:100%;height:100%;
      pointer-events:none;z-index:4;border-radius:inherit;overflow:visible;
    `;
    const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rect.setAttribute('x', '1'); rect.setAttribute('y', '1');
    rect.setAttribute('rx', '12');
    rect.style.cssText = `
      fill:none;stroke:rgba(251,179,36,0.85);stroke-width:1.5;
      stroke-dasharray: 1000; stroke-dashoffset: 1000;
      transition:stroke-dashoffset 0s;
    `;
    svg.appendChild(rect);
    card.appendChild(svg);

    /* Particle system */
    const particles = [];
    let animId = null;
    let isHovered = false;
    let tiltX = 0, tiltY = 0;

    function resizeRect() {
      const w = card.offsetWidth - 2;
      const h = card.offsetHeight - 2;
      rect.setAttribute('width', w);
      rect.setAttribute('height', h);
      const perim = 2 * (w + h);
      rect.style.strokeDasharray = perim;
      rect.style.strokeDashoffset = perim;
    }
    resizeRect();

    /* ── Mouse enter ── */
    card.addEventListener('mouseenter', () => {
      isHovered = true;
      resizeRect();
      const w = card.offsetWidth - 2;
      const h = card.offsetHeight - 2;
      const perim = 2 * (w + h);
      rect.style.transition = `stroke-dashoffset 0.9s cubic-bezier(0.16,1,0.3,1)`;
      rect.style.strokeDashoffset = '0';

      /* Emit particles */
      for (let i = 0; i < CONFIG.particles.count; i++) {
        setTimeout(() => spawnParticle(canvas, particles, card), i * 60);
      }
      if (!animId) animId = requestAnimationFrame(tickParticles);

      /* Idle glow brighten */
      card.style.setProperty('--cs-glow-opacity', '0.18');
    });

    /* ── Mouse leave ── */
    card.addEventListener('mouseleave', () => {
      isHovered = false;
      const w = card.offsetWidth - 2;
      const h = card.offsetHeight - 2;
      const perim = 2 * (w + h);
      rect.style.transition = `stroke-dashoffset 0.5s ease`;
      rect.style.strokeDashoffset = perim;

      /* Reset tilt */
      tiltX = 0; tiltY = 0;
      applyTilt(card, 0, 0);

      card.style.setProperty('--cs-glow-opacity', '0.06');
    });

    /* ── Mouse move — tilt + parallax ── */
    card.addEventListener('mousemove', (e) => {
      const rect2 = card.getBoundingClientRect();
      const cx = rect2.left + rect2.width / 2;
      const cy = rect2.top + rect2.height / 2;
      const dx = (e.clientX - cx) / (rect2.width / 2);
      const dy = (e.clientY - cy) / (rect2.height / 2);

      tiltX = lerp(tiltX, dy * CONFIG.tilt.max, 0.12);
      tiltY = lerp(tiltY, -dx * CONFIG.tilt.max, 0.12);
      applyTilt(card, tiltX, tiltY);

      /* Image parallax */
      const img = card.querySelector('.media img, .card__media img');
      if (img) {
        img.style.transform = `scale(1.08) translate(${dx * CONFIG.parallax.depth * -1}px, ${dy * CONFIG.parallax.depth * -1}px)`;
        img.style.transition = 'transform 0.1s ease-out';
      }
    });

    /* Particle tick */
    function tickParticles() {
      const ctx = canvas.getContext('2d');
      canvas.width = card.offsetWidth;
      canvas.height = card.offsetHeight;
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (let i = particles.length - 1; i >= 0; i--) {
        const p = particles[i];
        p.y -= p.vy;
        p.x += p.vx;
        p.life -= 0.018;
        p.size *= 0.985;
        if (p.life <= 0 || p.y < 0) { particles.splice(i, 1); continue; }
        ctx.globalAlpha = p.life * 0.7;
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;

      if (isHovered && particles.length < 24 && Math.random() < 0.25) {
        spawnParticle(canvas, particles, card);
      }

      if (particles.length > 0 || isHovered) {
        animId = requestAnimationFrame(tickParticles);
      } else {
        animId = null;
      }
    }
  }

  function spawnParticle(canvas, particles, card) {
    const w = card.offsetWidth;
    const h = card.offsetHeight;
    const colors = CONFIG.particles.colors;
    particles.push({
      x: w * 0.2 + Math.random() * w * 0.6,
      y: h * 0.6 + Math.random() * h * 0.35,
      vy: 0.6 + Math.random() * 1.2,
      vx: (Math.random() - 0.5) * 0.6,
      size: 1.5 + Math.random() * 2.5,
      life: 0.6 + Math.random() * 0.4,
      color: colors[Math.floor(Math.random() * colors.length)],
    });
  }

  function applyTilt(card, rx, ry) {
    card.style.transform = `perspective(${CONFIG.tilt.perspective}px) rotateX(${rx}deg) rotateY(${ry}deg) translateZ(0)`;
    card.style.transition = 'transform 0.15s ease-out';
  }

  /* ── Boot ── */
  function boot() {
    initCards();

    /* Re-run on AJAX pagination */
    const grid = document.getElementById('ProductGridContainer');
    if (grid) {
      new MutationObserver(initCards).observe(grid, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', initCards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
